import axios from "axios";
import { API } from "../context/AuthContext";

const CHUNK_SIZE = 4 * 1024 * 1024;
export const MAX_BATCH = 10;

export async function uploadFile(file, { caseId, note = "", replacesDocumentId = null, onProgress = () => {} }) {
  const init = await axios.post(`${API}/files/upload/init`, { filename: file.name, size: file.size });
  const { upload_id } = init.data;
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", upload_id);
    fd.append("index", i);
    fd.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    await axios.post(`${API}/files/upload/chunk`, fd);
    onProgress(Math.round(((i + 1) / total) * 100));
  }
  const body = { upload_id, context_note: note, case_id: caseId };
  if (replacesDocumentId) body.replaces_document_id = replacesDocumentId;
  const done = await axios.post(`${API}/files/upload/complete`, body);
  return done.data;
}
